import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import { makeStyles } from '@material-ui/core/styles';
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router';
import ResponsiveLayout from '../../Layouts/ResponsiveLayout';

import {
    Avatar, Box, Checkbox, Divider, Grid,
    FormGroup, FormControlLabel, IconButton,
    List, ListItem, ListItemAvatar,
    ListItemIcon, ListItemText,
    ListItemSecondaryAction, Paper,
    Tooltip, Typography
} from '@material-ui/core';

import {
    BackspaceTwoTone as BackspaceTwoToneIcon,
    GroupAddTwoTone as GroupAddTwoToneIcon
} from '@material-ui/icons';

import { StateContext, DispatchContext } from '../../../context/Provider';
import ParticipantModalForm from './ParticipantModalForm/ParticipantModalForm';
import ConfirmPasswordModal from '../../../components/Shared/ConfirmPasswordModal';

import ParticipantRequest from '../ParticipantRequest/ParticipantRequest'

const useStyles = makeStyles((theme) => ({
    root: {
        // width: '100%',
        // maxWidth: 360,
        // backgroundColor: theme.palette.background.paper,
    },
}));

const Participants = (props) => {

    const { classcode } = useParams();
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [dense, setDense] = useState(false);
    const [secondary, setSecondary] = useState(false);

    const classes = useStyles();
    const [participants, setParticipants] = useState([]);
    const [open, setOpen] = useState(false);

    async function fetchParticipants() {

        try {

            const response = await axiosConfig.get(`/participants?classcode=${classcode}`);
            const { data } = response.data;

            setParticipants(data);

        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    async function removeParticipant(studentID) {
        globalDispatch({type: 'setIsLoading', value: true});

        try {

            const response = await axiosConfig.post(`/participants/${studentID}`, {
                _method: "DELETE",
                classcode: classcode
            });

            const { status_code, message } = response.data;

            if (status_code == 'ok') {
                fetchParticipants();
                globalDispatch({type: 'setSnackbarMsg', value: 'Participant removed successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});
            }

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);

    }

    const [openConfirmPasswordDialog, setOpenConfirmPasswordDialog] = useState(false)
    const [deletingParticipantID, setDeletingParticipantID] = useState(null)

    const closeConfirmPasswordDialog = () => {
        setOpenConfirmPasswordDialog(false)
    }

    const passwordDialogConfirmed = (participant_id) => {
        removeParticipant(participant_id)
        setOpenConfirmPasswordDialog(false)
    }

    useEffect(() => {

        if (!classcode) {
            <Redirect to="/dashboard" />;
        }

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setTabValue', value: 2});
        globalDispatch({type: 'setShowTabs', value: true});

        const source = axiosConfig.CancelToken.source();
        fetchParticipants();
        return () => {
            source.cancel();
        }

    }, []);

    return (
        <ResponsiveLayout classcode={classcode}>
            <Box mt={2} />
            <Grid
                container
                spacing={2}
                justify="center"
            >

                { open ? (
                    <ParticipantModalForm
                        open={open}
                        handleClose={handleClose}
                        dialogTitle={`Add Participant`}
                        classcode={classcode}
                        fetchParticipants={fetchParticipants}
                    /> ) : null
                }

                <ConfirmPasswordModal
                    title="Please confirm your password"
                    message="Removing this participant will delete all activities and records of this student inside the class. To confirm this action, please enter your password."
                    dialogState={openConfirmPasswordDialog}
                    closeDialog={closeConfirmPasswordDialog}
                    dialogConfirmed={(participant) => {
                        passwordDialogConfirmed(participant);
                    }}
                    participantId={deletingParticipantID}
                />

                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>

                    { authState.user.role_id == 4 && <ParticipantRequest classCode={classcode} updateParticipant={fetchParticipants}/> }

                    <Paper elevation={1}>
                        <Box p={2}>
                            <Box mb={1}>
                                <Grid container justify="space-between">
                                    <Box pt={0.3} pb={1}>
                                        <Typography variant="h6">List of participants</Typography>
                                    </Box>
                                    { (authState.user.role_id === 4 || authState.user.role_id === 3) && (
                                        <Box pr={2}>
                                            <IconButton
                                                aria-label="add participant"
                                                onClick={(event) => { console.log('add student/s'); handleOpen(); }}>
                                                <Tooltip title="Invite Student/s">
                                                    <GroupAddTwoToneIcon fontSize="small" />
                                                </Tooltip>
                                            </IconButton>
                                        </Box>
                                    )}
                                </Grid>
                            </Box>

                            <Divider />

                            <List dense={dense}>
                                {participants.map((participant, i) => (
                                    <ListItem key={participant.id}>
                                        <ListItemAvatar>
                                            <Avatar alt="avatar" src={participant.avatar} />
                                        </ListItemAvatar>
                                        <ListItemText
                                            id={participant.id}
                                            primary={`${participant.student_name} | LRN: ${participant.lrn}`}
                                        />
                                        { (authState.user.role_id === 4 || authState.user.role_id === 3) && (
                                            <ListItemSecondaryAction>
                                                <IconButton
                                                    disableRipple
                                                    aria-label="delete"
                                                    onClick={() => {
                                                        // window.confirm(`Are you sure you want to remove this participant?`) && removeParticipant(participant.id)
                                                        setDeletingParticipantID(participant.id)
                                                        setOpenConfirmPasswordDialog(true)
                                                    }}>
                                                    <Tooltip title="Remove participant">
                                                        <BackspaceTwoToneIcon fontSize="small" />
                                                    </Tooltip>
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        )}
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </ResponsiveLayout>
    );
}

export default Participants;